class Credit {
    static calculate(sum,period,rate,init = 0) {
        let amount = sum - init;
        // let payment = amount*rate*(Math.pow(1+rate,period))/(Math.pow(1+rate,period))-1;
        let m_rate = rate / 12 / 100;
        let payment = amount * (m_rate + (m_rate / (Math.pow((1 + m_rate), period) - 1)))
        let overpayment = (payment * period) - amount;
        return {
            amount: amount,
            period: period,
            rate: rate,
            payment: Math.round(payment),
            overpayment: Math.round(overpayment),
        }
    }
}

export default Credit;
